import { Input, Row, Typography } from "antd";
import React, { useState } from "react";
import "./recoveryPassword.css";
import { LoginOutlined } from "@ant-design/icons";
import PFButton from "../../../components/functional_components/Button/PFButton";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { showSuccess } from "../../../utils/utilities";
import { useTranslation } from "react-i18next";
import Authentication from "../../../services/api/Authentication";

const RecoveryPassword = () => {
  const { t } = useTranslation();
  const { Text } = Typography;
  let navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const formikLogin = useFormik({
    initialValues: {
      username: "",
    },
    validate: (values) => {
      let errors = {};
      if (!values.username) {
        errors.username = "Required!";
      }
      return errors;
    },
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });
  const handleSubmit = async (values) => {
    setIsLoading(true);
    const data = {
      username: values.username,
    };
    /** Old code before penetration test on 09/01/2024 */
    // const password = await Authentication.recoveryPassword(data);
    // if (!password.error) {
    //   navigate('/login');
    //   showSuccess(t("recoveryPassword.SuccessNotificationContentMail"))
    // } else {
    //   showError(get(password, 'error.messageCode', 'ER000'));
    // }
    /** Edit after penetration test on 09/01/2024 */
    await Authentication.recoveryPassword(data);
    navigate("/login");
    showSuccess(t("recoveryPassword.SuccessNotificationContentMail"));
    setIsLoading(false);
  };
  return (
    <>
      <Row type="flex" justify="center">
        <Text className="title-recovery-password" level={3}>
          {t("recoveryPassword.title")}
        </Text>
      </Row>
      <Row type="flex" justify="center">
        <Text className="description-recovery-password" level={5}>
          {t("recoveryPassword.subTitle")}
        </Text>
      </Row>
      <Row type="flex" justify="center">
        <Input
          id="username"
          name="username"
          placeholder="Username"
          className="input-recovery-password"
          onChange={formikLogin.handleChange}
          onBlur={formikLogin.handleBlur}
          value={formikLogin.values.username}
        />
      </Row>
      <Row type="flex" justify="center">
        <PFButton
          type="primary"
          currentIcon={<LoginOutlined className="icon-medium" />}
          currentSize="large"
          className="button-recovery-password"
          clickCallback={formikLogin.submitForm}
          isLoading={isLoading}
          isDisabled={!(formikLogin.dirty && formikLogin.isValid)}
        />
      </Row>
    </>
  );
};

export default RecoveryPassword;
